import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

const TerminiCondizioni = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-header">
          <h1>Termini e condizioni</h1>
          <p>Ultimo aggiornamento: 29 giugno 2026</p>
        </div>

        <section>
          <h2>Servizi offerti</h2>
          <p>
            StudioInsieme offre servizi educativi di doposcuola, supporto compiti, metodo di studio, recupero scolastico
            e accompagnamento all'autonomia per studenti di scuola primaria e secondaria di primo grado.
          </p>
        </section>

        <section>
          <h2>Natura del servizio</h2>
          <p>
            Il servizio è educativo e didattico. Non vendiamo lo svolgimento dei compiti al posto dello studente e non
            garantiamo voti o risultati specifici. L'obiettivo è aiutare lo studente a studiare meglio, organizzarsi e
            affrontare i compiti con maggiore serenità.
          </p>
        </section>

        <section>
          <h2>DSA, BES e bisogni specifici</h2>
          <p>
            Possiamo offrire supporto allo studio anche a studenti con DSA/BES o difficoltà come dislessia, disgrafia,
            disortografia, discalculia, ADHD e difficoltà di attenzione o organizzazione. Non effettuiamo diagnosi,
            certificazioni, terapia o prestazioni sanitarie.
          </p>
        </section>

        <section>
          <h2>Piani e pacchetti personalizzati</h2>
          <p>
            I piani standard hanno il prezzo indicato sul sito. Per bisogni più complessi è prevista una call conoscitiva
            con il genitore e, se utile, con lo studente. Solo dopo la call viene proposto un pacchetto personalizzato con
            obiettivi, durata, frequenza e prezzo confermati prima del pagamento.
          </p>
        </section>

        <section>
          <h2>Responsabilità della famiglia</h2>
          <p>
            La famiglia si impegna a fornire informazioni corrette su età, classe, bisogni scolastici, disponibilità e
            eventuali indicazioni utili per organizzare il percorso.
          </p>
        </section>

        <section>
          <h2>Pagamenti</h2>
          <p>
            I pagamenti online sono gestiti tramite Stripe. L'attivazione del servizio avviene dopo conferma
            dell'iscrizione, disponibilità del percorso e ricezione del pagamento, salvo diversi accordi scritti.
          </p>
        </section>

        <div className="legal-actions">
          <Button asChild className="btn-primary">
            <Link to="/iscrizione">Vai all'iscrizione</Link>
          </Button>
          <Button asChild variant="outline">
            <Link to="/rimborsi">Politica rimborsi</Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TerminiCondizioni;
